import * as actionTypes from '../actions/actionTypes';
import moment from 'moment';

const initState = {
  loading: false,
  appUsers: null,
};

export default (state = initState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_APP_USERS_START:
      return { ...state, loading: true };
    case actionTypes.FETCH_APP_USERS_END:
      const { appUsers } = action;
      return { ...state, loading: false, appUsers };
    case actionTypes.UPDATE_APP_USERS_START:
      return { ...state, loading: true };
    case actionTypes.UPDATE_APP_USERS_END:
      // work around solution for reloading after update
      window.location.reload(false);
      return { ...state, loading: false };
    default:
      return state;
  }
};

export const parseAppUsers = appUsers => {
  if (!appUsers) return null;
  return appUsers.map(e => {
    switch (e.approval_status) {
      case -1:
        e['status'] = 'Rejected';
        break;
      case 0:
        e['status'] = '';
        break;
      case 1:
        e['status'] = 'Pending';
        break;
      case 2:
        e['status'] = 'Approved Staff';
        break;
      case 3:
        e['status'] = 'Deleted';
        break;
      default:
        e['status'] = '';
    }

    if (typeof e.created_at === typeof 0) {
      const timeUnix = moment.unix(e.created_at);
      e.CreatedAt = timeUnix.format('h:mm A, DD-MM-YYYY');
    }

    if (typeof e.updated_at === typeof 0) {
      const timeUnix2 = moment.unix(e.updated_at);
      e.UpdatedAt = timeUnix2.format('h:mm A, DD-MM-YYYY');
    }

    return {
      id: e.ID,
      phone_id: e.PhoneID,
      approval_status: e.status,
      company: e.Company,
      name: e.Name,
      role: e.Role,
      phone: e.phone,
      created_at: e.CreatedAt,
      updated_at: e.UpdatedAt,
      unix_updated_at: e.updated_at,
    };
  });
};



// WEBPACK FOOTER //
// ./src/store/reducers/appUser.js